import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeFi from '@angular/common/locales/fi';
import localeNb from '@angular/common/locales/nb';
import localeSe from '@angular/common/locales/sv';
import { provideTracking } from '@keatech/tracking';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore, RouterState } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePrimeNG } from 'primeng/config';
import { environment } from '~environment';
import { loginFeature } from '~login/store/login.reducer';
import { locales } from '~shared/models/locales';
import { statusFeature } from '~status/store/status.reducer';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { VerifyTheme } from './core/prime/kea.theme';
import { TRACKING_CONFIG } from './core/trackingConfig';

const locale: locales = (localStorage.getItem('locale') ?? 'da-DK') as locales;
registerLocaleData(localeDa, 'da-DK');
registerLocaleData(localeEn, 'en-GB');
registerLocaleData(localeSe, 'sv-SE');
registerLocaleData(localeNb, 'nb-NO');
registerLocaleData(localeFi, 'fi-FI');
registerLocaleData(localeDe, 'de-DE');

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        provideStore(
            {
                [loginFeature.name]: loginFeature.reducer,
                [statusFeature.name]: statusFeature.reducer,
            },
            {
                runtimeChecks: {
                    strictStateImmutability: true,
                    strictActionImmutability: true,
                    strictStateSerializability: true,
                    strictActionSerializability: true,
                    strictActionWithinNgZone: true,
                    strictActionTypeUniqueness: true,
                },
            }
        ),
        provideRouterStore({ stateKey: 'router', routerState: RouterState.Minimal }), // to use Full turn of strict serializability
        provideEffects([]),
        provideStoreDevtools({
            maxAge: 25,
            logOnly: environment.production,
            name: 'Keatech verify',
            connectInZone: true,
        }),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: VerifyTheme,
                options: {
                    darkModeSelector: 'none',
                },
            },
        }),
        provideTranslateService({
            loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
        }),
        { provide: LOCALE_ID, useValue: locale },
        provideHttpClient(withXhr(), withInterceptorsFromDi(), withInterceptors([authInterceptor])),
        provideTracking(TRACKING_CONFIG),
    ],
};
